import {type ReactNode} from 'react';

import {type DataTypeProvider} from '@devexpress/dx-react-grid';

export function OptixTableDataTypeStringFormatter({
  value,
}: DataTypeProvider.ValueFormatterProps): ReactNode {
  return value;
}
